import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Details.scss';

const PERIOD_UNITS = ['Months', 'Years'];

function Details({ payment, price, period }) {
  return (
    <ul className={styles.root}>
      <li className={styles.row}>
        <span>Next payment</span>
        <span className={styles.detail}>{payment}</span>
      </li>
      <li className={styles.row}>
        <span className={classNames({ [styles.priceless]: !price })}>Fee</span>
        <span
          className={classNames(
          styles.detail,
              { [styles.price]: price },
          styles[period.toLowerCase()],
        )}
        >{price}
        </span>
      </li>
    </ul>
  );
}

Details.propTypes = {
  payment: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  period: PropTypes.oneOf(PERIOD_UNITS).isRequired,
};

export default Details;
